module.exports = __webpack_public_path__ + "static/media/stories.b582a7f8.svg";